import { EventReview } from '../components/EventReview/EventReview';

const EventReviewScreen = () => <EventReview />;
export default EventReviewScreen;
